import type { IMediaFile } from "@/shared/types";
import { createContext, useContext, type ReactNode } from "react";
import {
  MediaLibCategoryEnum,
  MediaLibPresetEnum,
  type IMediaLibDialogItem,
  type TElement,
} from "../../types";

interface IState {
  preset: MediaLibPresetEnum;
  mediaPreset?: MediaLibPresetEnum;
  source?: "default" | "settings";

  category: MediaLibCategoryEnum;
  selectedFolderId: string | null;

  updateFile: (id: string, data: Partial<IMediaFile>) => void;
  removeFile: (id: string) => void;

  view?: "panel" | "dialog";
  onSelect?: (item: IMediaFile) => void;
  selectedItems?: IMediaLibDialogItem[];
  isMultiSelect?: boolean;
  elementWrapper?: React.ComponentType<{
    children: React.ReactNode;
    element: TElement;
    disabled?: boolean;
  }>;
}

const initState: IState = {
  preset: MediaLibPresetEnum.All,
  mediaPreset: MediaLibPresetEnum.All,

  category: MediaLibCategoryEnum.AllFiles,
  selectedFolderId: null,
  source: "default",
  view: "panel",

  updateFile: () => {},
  removeFile: () => {},
};

export const MediaLibFilesCtx = createContext<IState>(initState);

interface IProps {
  children: ReactNode;
  ctxState: IState;
}

export const MediaLibFilesCtxProvider = ({ children, ctxState }: IProps) => {
  return (
    <MediaLibFilesCtx.Provider value={ctxState}>
      {children}
    </MediaLibFilesCtx.Provider>
  );
};

export const useMediaLibFilesCtx = () => {
  const ctx = useContext(MediaLibFilesCtx);
  if (!ctx)
    throw Error("useMediaLibFilesCtx: MediaLibFilesCtx is not defined!");
  return ctx;
};
